export default "__VITE_ASSET__BIOjVdhP__"